// Only intercept a gesture after the host explicitly confirms scroll support.
export function bindFormScroll({slug='',origin=null,legacy=false}={}) {
 if(window.parent===window)return ()=>{};
 let hostOrigin=null;
 const receive=e=>{
  if(e.source!==window.parent)return;
  if(origin && e.origin!==origin)return;
  if(e.data?.type==='hustleshield-scroll-ready' || (legacy && e.data?.type==='yates-invoice-viewport'))
   hostOrigin=e.origin;
 };
 const wheel=e=>{
  if(!hostOrigin||e.defaultPrevented||e.ctrlKey||e.metaKey)return;
  if(document.querySelector('dialog[open]'))return;
  const scale=e.deltaMode===1?16:e.deltaMode===2?innerHeight:1;
  const dy=e.deltaY*scale,dx=e.deltaX*scale;
  if(!Number.isFinite(dy)||!Number.isFinite(dx))return;
  // Preserve native scrolling within dropdowns, textareas and scrollable panels.
  for(let node=e.target;node && node!==document.body;node=node.parentElement){
   if(node.tagName==='SELECT')return;
   const css=getComputedStyle(node);
   if(/auto|scroll/.test(css.overflowY) && node.scrollHeight>node.clientHeight+1 &&
      ((dy>0 && node.scrollTop+node.clientHeight<node.scrollHeight-1)||(dy<0 && node.scrollTop>0)))return;
  }
  const scroller=document.scrollingElement;
  if(scroller && ((dy>0 && scroller.scrollTop+innerHeight<scroller.scrollHeight-2)||(dy<0 && scroller.scrollTop>0)))return;
  window.parent.postMessage(legacy?{type:'yates-invoice-scroll',dy,dx}:{hpBlocks:true,hcFormScroll:true,slug,scrollY:dy},hostOrigin);
  if(e.cancelable)e.preventDefault();
 };
 window.addEventListener('message',receive);
 window.addEventListener('wheel',wheel,{passive:false});
 window.parent.postMessage({hpBlocks:true,slug,requestScrollBridge:true},origin||'*');
 return ()=>{window.removeEventListener('message',receive);window.removeEventListener('wheel',wheel)};
}
